export default __webpack_public_path__ + "static/media/Transparent.7d8a4371.webp";